import { inject, Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private readonly _snackBar = inject(MatSnackBar)
  constructor() {}

  openSnackBar(message: string, action: string = 'close') {
    this._snackBar.open(message, action, {
      duration: 5000, // 5 sec
    })
  }

  openSnackBarError(message: string, action: string = 'close') {
    this._snackBar.open(message, action, { panelClass: ['snackbar-error'] })
  }

  showToasterSurfaceLimit() {
    this.openSnackBar(
      'You have exceeded the AREA SELECTION LIMIT for the free selection as well as for running calculation modules! Please select a smaller area.',
    )
  }
}
